import { render, staticRenderFns } from "./PdRenewalFields.vue?vue&type=template&id=6dc2a4e8&scoped=true&"
import script from "./PdRenewalFields.vue?vue&type=script&lang=js&"
export * from "./PdRenewalFields.vue?vue&type=script&lang=js&"
import style0 from "./PdRenewalFields.vue?vue&type=style&index=0&id=6dc2a4e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc2a4e8",
  null
  
)

export default component.exports